import addToCartAjax from 'components/add-to-cart/addToCartAjax';

export default (function () {
    const init = () => {
        const atcProductPopup = document.querySelector('.atc-product-popup');

        if (atcProductPopup) {
            const addToCartBtns = document.querySelectorAll('.atc-product-popup .product-tile .btn-add-to-cart');

            if (addToCartBtns) {
                addToCartBtns.forEach((button) => {
                    button.addEventListener('click', (e) => {
                        e.preventDefault();
                        const data = {
                            productId: button.dataset.productid,
                            route: button.dataset.route,
                            multipleProductIds: button.dataset.multipleProductids
                        };
                        addToCartAjax(button, data.productId, data.route, false, data.multipleProductIds ?? false);
                    });
                });
            }
        }
    };

    return {
        init: init
    };
})();
